import React, { useState } from 'react';
import ReactLoader from 'react-loading';

import { ThemeProps, withTheme } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import UserList from 'components/UserList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';

import { Container, Content, Label, Value } from './styles';

interface BranchCompanySelectProps extends ThemeProps<any> {
  title: string;
  buttonLabel: string;
  value?: GroupedListModel;
  options: GroupedListModel[];
  disabled?: boolean;
  onChange: (value: GroupedListModel) => void;
  isLoading: boolean;
  testId?: string;
}

const BranchCompanySelect = ({
  title,
  buttonLabel,
  disabled,
  value,
  options,
  onChange,
  isLoading,
  testId,
}: BranchCompanySelectProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useStoreTranslation();
  const [showUserList, setShowUserList] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showGuestForm, setShowGuestForm] = useState(false);

  const handleShowUserList = () => {
    setShowUserList(true);
  };

  const handleCloseUserList = () => {
    setShowUserList(false);
  };

  return (
    <>
      <Container>
        <Content onClick={() => (disabled ? null : handleShowUserList())} data-testid={testId}>
          <Label>{title}</Label>
          <Value active={!!value}>
            {isLoading ? (
              <ReactLoader type="spin" color={ColorPalette.HEX.Gainsboro} width={24} height={24} />
            ) : (
              <>{`${value?.name || title}`}</>
            )}
          </Value>
        </Content>
        <img src="/images/right-arrow.svg" alt="right-arrow" />
        <ApplicationOverlayContent sidebar show={showUserList} onClose={handleCloseUserList}>
          <UserList
            title={title}
            userList={options}
            onConfirmSelection={(values) => onChange(values[0])}
            onCloseSelectionScreen={handleCloseUserList}
            alreadySelected={value ? [value] : []}
            isLoading={isLoading}
            selectableType="radio"
            singleSelect
            isModal
            buttonLabel={buttonLabel}
            noAdd={true}
            addIcon="/images/guest-act.svg"
            hasFavorites={false}
          />
        </ApplicationOverlayContent>
      </Container>
    </>
  );
};

export default withTheme(BranchCompanySelect);
